module.exports = __webpack_public_path__ + "videos/mts-main-products-chats.f8470fb.webm";